import { Component, inject, input, linkedSignal } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { Store } from '@ngrx/store'

import { FlxTabBarModule, FlxTabComponent } from '@flowx/angular-ui-toolkit'
import { InstanceWorkflowsComponent } from '@flowx/designer/shared/components/instance-workflows/instance-workflows.component'
import { ProcessInstance } from '@flowx/designer/shared/entities/process-instance.types'
import { UiFlowSession } from '@flowx/designer/shared/entities/ui-flow-sessions.types'
import { selectQueryParam } from '@flowx/designer/shared/store/selectors/router.selectors'

import { UiFlowSessionAuditLogsComponent } from '../ui-flow-session-audit-logs/ui-flow-session-audit-logs.component'
import { UiFlowSessionProcessesComponent } from '../ui-flow-session-processes/ui-flow-session-processes.component'
import { UiFlowSessionVariablesComponent } from '../ui-flow-session-variables/ui-flow-session-variables.component'

export enum TabHeaders {
  AUDIT = 'Audit Log',
  PROCESSES = 'Processes',
  VARIABLES = 'Variables',
  WORKFLOWS = 'Workflows',
}

@Component({
  selector: 'flx-ui-flow-session-tabs',
  imports: [
    FlxTabBarModule,
    UiFlowSessionAuditLogsComponent,
    UiFlowSessionProcessesComponent,
    UiFlowSessionVariablesComponent,
    InstanceWorkflowsComponent,
  ],
  templateUrl: './ui-flow-session-tabs.component.html',
  styleUrl: './ui-flow-session-tabs.component.scss',
})
export class UiFlowSessionTabsComponent {
  #store = inject(Store)
  #router = inject(Router)
  #route = inject(ActivatedRoute)

  uiFlowSession = input.required<UiFlowSession>()
  processInstances = input.required<ProcessInstance[]>()

  tabs = [
    { id: 'variables', index: 0, header: TabHeaders.VARIABLES, visible: true },
    { id: 'audit', index: 1, header: TabHeaders.AUDIT, visible: true },
    { id: 'processes', index: 2, header: TabHeaders.PROCESSES, visible: true },
    { id: 'workflows', index: 3, header: TabHeaders.WORKFLOWS, visible: true },
  ]
  selectedTabIndex = linkedSignal(
    () =>
      this.tabs.find((tab) => tab.id === this.#store.selectSignal(selectQueryParam('tab'))())
        ?.index ?? 0
  )

  readonly TabHeaders = TabHeaders

  onTabChange(tab: FlxTabComponent): void {
    const tabQueryParam = this.tabs.find((item) => item.header === tab.label())?.id
    this.#router.navigate([], {
      relativeTo: this.#route,
      queryParams: {
        tab: tabQueryParam,
      },
      queryParamsHandling: 'merge',
    })
  }
}
